import { useRef, useState } from "react";
import { Table } from "./Table";
import { Toast } from "primereact/toast";
import { IPermissionProps } from "../../../models/Login";
import { Form } from "./Form";

export interface IModel {
    open: boolean;
}

export const LeadScrappingSetting = (permissions?: IPermissionProps) => {
    const [modal, setModal] = useState({ open: false } as IModel);
    const [reload, setReload] = useState(false);

    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ open: false });
    };

    return (
        <>
            {/* <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} /> */}
            <Table setModal={setModal} toast={toast} reload={reload} />
            <Form open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
            <Toast ref={toast} />
        </>
    );
}